import { Injectable } from '@angular/core';
import { Availability, AvailabilityDisplay, AvailabilityHelperService, Product, STOCK_STATUS } from 'gung-standard';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SjoborgAvailabilityHelperService extends AvailabilityHelperService {
  public getAvailabilityDisplay(availability: Availability, product: Product = null, details?: boolean): Observable<AvailabilityDisplay> {
    if ('' + product?.extra?.ar?.anskaffningssatt === '2') {
      return of({
        class: {},
        value: this.translateService.instant('SUPPLIER_STOCK')
      });
    } else if (availability && availability.currentAvailability === 0) {
      return of({
        class: {},
        value: this.translateService.instant('SUPPLIER_STOCK')
      });
    } else {
      return super.getAvailabilityDisplay(availability, product, details);
    }
  }

  protected getValueFromStatus(status: STOCK_STATUS, isSales: boolean, availability: Availability, product?: Product): string {
    if (!availability || status !== STOCK_STATUS.IN_STOCK) {
      return super.getValueFromStatus(status, isSales, availability, product);
    }

    const localeLang = this.languageConfigService.getLanguages().find(
      lang => lang.short === this.translateService.currentLang
    )?.locale || 'en-GB';
    const currentAvailabilityLocale: string = availability.currentAvailability.toLocaleString(localeLang);
    const stock: string = !isSales && availability.currentAvailability > 50 ? '50+' : currentAvailabilityLocale;

    return this.translateService.instant('STOCK_AT_LOCATION', { location: 'Sjöborg', value: stock });
  }
}
